import moment from 'moment';

const getEPGData = async function (stationName) {
  const start = moment().startOf('day').hours(6);
  const end = moment(start).add(1, 'day');

  if (moment().hour() < 6) {
    start.subtract(1, 'day');
    end.subtract(1, 'day');
  }

  console.log(process.env.NODE_ENV);

  const url =
    process.env.NODE_ENV === 'production'
      ? `https://kanstudiocalapi.azurewebsites.net/api/${stationName}`
      : // `https://10.100.6.3/api/${stationName}`
        `https://localhost:7161/api/${stationName}`;

  const fetchedData = await fetch(url, {
    Headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((data) => {
      let EPGData = {};
      for (let epgArray in data.EPG) {
        EPGData[epgArray] = data.EPG[epgArray].map((x) => {
          return {
            epgName: x['epg_name'],
            hebDesc: x['hebrew_desc'],
            idCode: x['id_code'],
            startTime: moment(x['start_time']),
            endTime: moment(x['end_time']),
          };
        });
      }
      data.EPG = EPGData;
      return data;
    });

  return fetchedData;
};

export default getEPGData;
